export const getCountryCode = (country, countries = {}) =>
  Object.keys(countries)[Object.values(countries).indexOf(country)];
